export enum TiposAtendimentosSolar {
  LIGACAO = 0, // Ligação
  INICIAL = 1, // Inicial
  RETORNO = 2, // Retorno
  RECEPCAO = 3, // Recepção
  NUCLEO = 4, // Apoio de Núcleo Especializado
  ANOTACAO = 5, // Anotação
  PROCESSO = 6, // Processo
  VISITA = 7, // Visita ao Preso
  INTERESSADO = 8, // Atendimento ao Interessado
  ENCAMINHAMENTO = 9, // Encaminhamento
  ATIVIDADE = 10, // tividade
  RECLAMACAO = 11, // Reclamacao pelo disk
  INFORMACAO = 12, // Informacao pelo disk
  OFICIO = 13, // Ofício encaminhado
  OFICIO_FINALIZADO = 14, // Ofício finalizado
  DESARQUIVAMENTO = 998, // Atendimento desarquivado
  ARQUIVAMENTO = 999, // Atendimento arquivado
  NUCLEO_PEDIDO = 1031, // Solicitação de Apoio de Núcleo Especializado
  NOTIFICACAO = 1092, // Notificação
}

export const TIPOS_ATENDIMENTO_SOLAR_OPCOES: { value: number; label: string }[] = [
  { value: TiposAtendimentosSolar.LIGACAO, label: 'Ligação' },
  { value: TiposAtendimentosSolar.INICIAL, label: 'Inicial' },
  { value: TiposAtendimentosSolar.RETORNO, label: 'Retorno' },
  { value: TiposAtendimentosSolar.RECEPCAO, label: 'Recepção' },
  { value: TiposAtendimentosSolar.NUCLEO, label: 'Apoio de Núcleo Especializado' },
  { value: TiposAtendimentosSolar.ANOTACAO, label: 'Anotação' },
  { value: TiposAtendimentosSolar.PROCESSO, label: 'Processo' },
  { value: TiposAtendimentosSolar.VISITA, label: 'Visita ao Preso' },
  { value: TiposAtendimentosSolar.INTERESSADO, label: 'Atendimento ao Interessado' },
  { value: TiposAtendimentosSolar.ENCAMINHAMENTO, label: 'Encaminhamento' },
  { value: TiposAtendimentosSolar.ATIVIDADE, label: 'Atividade' },
  { value: TiposAtendimentosSolar.RECLAMACAO, label: 'Reclamação pelo disk' },
  { value: TiposAtendimentosSolar.INFORMACAO, label: 'Informação pelo disk' },
  { value: TiposAtendimentosSolar.OFICIO, label: 'Ofício encaminhado' },
  { value: TiposAtendimentosSolar.OFICIO_FINALIZADO, label: 'Ofício finalizado' },
  { value: TiposAtendimentosSolar.DESARQUIVAMENTO, label: 'Atendimento desarquivado' },
  { value: TiposAtendimentosSolar.ARQUIVAMENTO, label: 'Atendimento arquivado' },
  { value: TiposAtendimentosSolar.NUCLEO_PEDIDO, label: 'Solicitação de Apoio de Núcleo Especializado' },
  { value: TiposAtendimentosSolar.NOTIFICACAO, label: 'Notificação' },
];
